// extracted by mini-css-extract-plugin
module.exports = {"tableRow":"DesktopTableRow_tableRow__BpYqh"};